/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path context
 * @description Context which can store values which are visible in the UI
 */
import React from "react";
export type IReportContext = {
  kpis: string[];
  projects: string[];
  sendValue: <K extends keyof IReportContext>(
    name: K,
    value: IReportContext[K]
  ) => void;
  getKpis: () => string[];
  getProjects: () => string[];
};
type StateSelector<T extends IReportContext, U> = (state: T) => U;
export type UseContextStore<T extends IReportContext> = {
  (): T;
  <U>(selector: StateSelector<T, U>): U;
};
export const ReportContext = React.createContext<IReportContext>({
  kpis: [],
  projects: [],
  sendValue: () => {},
  getKpis: () => [],
  getProjects: () => [],
});
const useAppContextFn = (
  fn?: (ctx: IReportContext) => IReportContext[keyof IReportContext]
) => {
  const ctx = React.useContext(ReportContext);
  if (!fn) {
    return ctx;
  }
  return fn(ctx);
};
export const useReportContextHook: UseContextStore<IReportContext> =
  useAppContextFn as any;
